import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicantDetailBehaviorCommunicationService {
  private tabUpdateSubject = new Subject<void>();
  
  tabUpdate$ = this.tabUpdateSubject.asObservable();

  requestTabUpdate(): void {
    this.tabUpdateSubject.next();
  }
}
